import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/oplatformapps";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async delete(params: any) {
    return api.delete(params);
  }

  @Action
  async select(params: any) {
    return api.select(params);
  }

  @Action
  async subscribeReply(params: any) {
    return api.subscribeReply(params);
  }

  @Action
  async saveSubscribeReply(params: any) {
    return api.saveSubscribeReply(params);
  }

  @Action
  async autoReply(params: any) {
    return api.autoReply(params);
  }

  @Action
  async saveAutoReply(params: any) {
    return api.saveAutoReply(params);
  }

  @Action
  async menus(params: any) {
    return api.menus(params);
  }

  @Action
  async addmenu(params: any) {
    return api.addmenu(params);
  }

  @Action
  async editmenu(params: any) {
    return api.editmenu(params);
  }

  @Action
  async getmenu(params: any) {
    return api.getmenu(params);
  }

  @Action
  async deletemenu(params: any) {
    return api.deletemenu(params);
  }

  @Action
  async submitserver(params: any) {
    return api.submitserver(params);
  }

  @Action
  async keywords(params: any) {
    return api.keywords(params);
  }

  @Action
  async addkeyword(params: any) {
    return api.addkeyword(params);
  }

  @Action
  async editkeyword(params: any) {
    return api.editkeyword(params);
  }

  @Action
  async getkeyword(params: any) {
    return api.getkeyword(params);
  }

  @Action
  async deletekeyword(params: any) {
    return api.deletekeyword(params);
  }

  @Action
  async news(params: any) {
    return api.news(params);
  }

  @Action
  async addnews(params: any) {
    return api.addnews(params);
  }

  @Action
  async editnews(params: any) {
    return api.editnews(params);
  }

  @Action
  async getnews(params: any) {
    return api.getnews(params);
  }

  @Action
  async deletenews(params: any) {
    return api.deletenews(params);
  }

  @Action
  async newsselect(params: any) {
    return api.newsselect(params);
  }

  @Action
  async templatemessages(params: any) {
    return api.templatemessages(params);
  }

  @Action
  async addtemplatemessage(params: any) {
    return api.addtemplatemessage(params);
  }

  @Action
  async edittemplatemessage(params: any) {
    return api.edittemplatemessage(params);
  }

  @Action
  async gettemplatemessage(params: any) {
    return api.gettemplatemessage(params);
  }

  @Action
  async deletetemplatemessage(params: any) {
    return api.deletetemplatemessage(params);
  }

  @Action
  async templates(params: any) {
    return api.templates(params);
  }

  @Action
  async addtemplate(params: any) {
    return api.addtemplate(params);
  }

  @Action
  async edittemplate(params: any) {
    return api.edittemplate(params);
  }

  @Action
  async gettemplate(params: any) {
    return api.gettemplate(params);
  }

  @Action
  async deletetemplate(params: any) {
    return api.deletetemplate(params);
  }

  @Action
  async templateselect(params: any) {
    return api.templateselect(params);
  }

  @Action
  async fans(params: any) {
    return api.fans(params);
  }

  @Action
  async getfan(params: any) {
    return api.getfan(params);
  }

  @Action
  async addfan(params: any) {
    return api.addfan(params);
  }

  @Action
  async editfan(params: any) {
    return api.editfan(params);
  }

  @Action
  async fansselect(params: any) {
    return api.fansselect(params);
  }

  @Action
  async deletefan(params: any) {
    return api.deletefan(params);
  }

  @Action
  async groups(params: any) {
    return api.groups(params);
  }

  @Action
  async addgroup(params: any) {
    return api.addgroup(params);
  }

  @Action
  async editgroup(params: any) {
    return api.editgroup(params);
  }

  @Action
  async getgroup(params: any) {
    return api.getgroup(params);
  }

  @Action
  async deletegroup(params: any) {
    return api.deletegroup(params);
  }

  @Action
  async messages(params: any) {
    return api.messages(params);
  }

  @Action
  async weapps(params: any) {
    return api.weapps(params);
  }

  @Action
  async addweapp(params: any) {
    return api.addweapp(params);
  }
  @Action
  async delweapp(params: any) {
    return api.delweapp(params);
  }
  @Action
  async searchStatus(params: any) {
    return api.searchStatus(params);
  }

  @Action
  async editweapp(params: any) {
    return api.editweapp(params);
  }

  @Action
  async detailweapp(params: any) {
    return api.detailweapp(params);
  }

  @Action
  async deleteweapp(params: any) {
    return api.deleteweapp(params);
  }

  @Action
  async gettemplatedraftlist(params: any) {
    return api.gettemplatedraftlist(params);
  }

  @Action
  async gettemplatelist(params: any) {
    return api.gettemplatelist(params);
  }

  @Action
  async addtotemplate(params: any) {
    return api.addtotemplate(params);
  }

  @Action
  async deletecodetemplate(params: any) {
    return api.deletecodetemplate(params);
  }

  @Action
  async getQrcode(params: any) {
    return api.getQrcode(params);
  }

  @Action
  async submitAudit(params: any) {
    return api.submitAudit(params);
  }

  @Action
  async release(params: any) {
    return api.release(params);
  }

  @Action
  async testers(params: any) {
    return api.testers(params);
  }

  @Action
  async bindTester(params: any) {
    return api.bindTester(params);
  }

  @Action
  async unbindTester(params: any) {
    return api.unbindTester(params);
  }

  @Action
  async plugin(params: any) {
    return api.plugin(params);
  }

  @Action
  async getaccountbasicinfo(params: any) {
    return api.getaccountbasicinfo(params);
  }

  @Action
  async modifydomain(params: any) {
    return api.modifydomain(params);
  }

  @Action
  async setwebviewdomain(params: any) {
    return api.setwebviewdomain(params);
  }

  @Action
  async commit(params: any) {
    return api.commit(params);
  }

  @Action
  async setnickname(params: any) {
    return api.setnickname(params);
  }

  @Action
  async modifyheadimage(params: any) {
    return api.modifyheadimage(params);
  }

  @Action
  async modifysignature(params: any) {
    return api.modifysignature(params);
  }

  @Action
  async getallcategories(params: any) {
    return api.getallcategories(params);
  }

  @Action
  async getcategoriesbytype(params: any) {
    return api.getcategoriesbytype(params);
  }

  @Action
  async getcategory(params: any) {
    return api.getcategory(params);
  }

  @Action
  async addcategory(params: any) {
    return api.addcategory(params);
  }

  @Action
  async deletecategory(params: any) {
    return api.deletecategory(params);
  }

  @Action
  async getLatestAuditstatus(params: any) {
    return api.getLatestAuditstatus(params);
  }

  @Action
  async materailList(params: any) {
    return api.materialList(params);
  }

  @Action
  async getwxasearchstatus(params: any) {
    return api.getwxasearchstatus(params);
  }

  @Action
  async changewxasearchstatus(params: any) {
    return api.changewxasearchstatus(params);
  }

  @Action
  async setprivacysetting(params: any) {
    return api.setprivacysetting(params);
  }

  @Action
  async getprivacysetting(params: any) {
    return api.getprivacysetting(params);
  }

  @Action
  async wxaauth(params: any) {
    return api.wxaauth(params);
  }

  @Action
  async wxaicp(params: any) {
    return api.wxaicp(params);
  }
}
